import { render, staticRenderFns } from "./UserDataTableRow.vue?vue&type=template&id=e52f4f6a&"
import script from "./UserDataTableRow.vue?vue&type=script&lang=js&"
export * from "./UserDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports